/**
 * le7-mlp-scrolling-image
 * Drives two effects for every instance of the "Scrolling image" section:
 *   1. Parallax  — translates the background image slower than the page scroll.
 *   2. Reveal    — fades + slides overlay blocks in when the section enters view.
 *
 * Both effects are disabled when the user prefers reduced motion.
 */
(function () {
  'use strict';

  var SELECTOR = '[data-section-type="le7-msi"]';
  var reduceMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------------------------------------------------------- Reveal */
  function initReveal(root) {
    var targets = root.querySelectorAll('[data-msi-reveal]');
    if (!targets.length) return;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      targets.forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );

    targets.forEach(function (el) {
      observer.observe(el);
    });
  }

  /* -------------------------------------------------------------- Parallax */
  function initParallax(root) {
    if (reduceMotion) return;
    if (root.getAttribute('data-parallax') !== 'true') return;

    var img = root.querySelector('[data-msi-parallax]');
    if (!img) return;

    var intensity = parseFloat(root.getAttribute('data-parallax-intensity')) || 0;
    if (intensity <= 0) return;

    var ticking = false;

    function update() {
      ticking = false;
      var rect = root.getBoundingClientRect();
      var viewportH = window.innerHeight || document.documentElement.clientHeight;

      // Skip work when the section is well outside the viewport.
      if (rect.bottom < 0 || rect.top > viewportH) return;

      // progress: -1 (section just below viewport) -> 1 (just above).
      var progress = (rect.top + rect.height / 2 - viewportH / 2) / (viewportH / 2 + rect.height / 2);
      var offset = -progress * intensity;
      img.style.transform = 'translate3d(0, ' + offset.toFixed(2) + 'px, 0)';
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  /* ------------------------------------------------------------------ Init */
  function init(root) {
    if (!root || root.dataset.msiInit === 'true') return;
    root.dataset.msiInit = 'true';
    initReveal(root);
    initParallax(root);
  }

  function initAll(scope) {
    var nodes = (scope || document).querySelectorAll(SELECTOR);
    nodes.forEach(function (node) {
      init(node);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  // Re-init when a section is added/reloaded in the theme editor.
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
